export const qk = {
  authMe: ['auth', 'me'] as const,
  /** Prefix for `removeQueries` / `invalidateQueries` across all cached profile rows */
  profileScope: ['profile', 'me'] as const,
  /** Include `userId` so another role/account does not reuse stale success or error state */
  profile: (userId: string) => [...qk.profileScope, userId] as const,
  mentorVerification: ['mentor', 'verification-status'] as const,
  parentDashboard: ['dashboard', 'parent'] as const,
  studentDashboard: ['dashboard', 'student'] as const,
  mentorDashboard: ['dashboard', 'mentor'] as const,
  lessonsDashboard: (role: string, studentId?: string) =>
    ['lessons', 'dashboard', role, studentId ?? 'all'] as const,
  lessonsList: (role: string) => ['lessons', 'list', role] as const,
  lessonDetail: (lessonId: string) => ['lessons', 'detail', lessonId] as const,
  lessonSessions: (lessonId: string, tab: string, page: number) =>
    ['lessons', lessonId, 'sessions', tab, page] as const,
  sessionsUpcoming: ['sessions', 'upcoming'] as const,
  sessionDetail: (sessionId: string) => ['sessions', sessionId] as const,
  transcriptStatus: (sessionId: string) => ['sessions', sessionId, 'transcript-status'] as const,
  sessionTranscript: (sessionId: string) => ['sessions', sessionId, 'transcript'] as const,
  quizDetail: (quizId: string) => ['quizzes', quizId] as const,
  aiSummary: (sessionId: string) => ['ai', 'summary', sessionId] as const,
  aiQuizMentor: (sessionId: string) => ['ai', 'quiz', 'mentor', sessionId] as const,
  aiQuizStudent: (sessionId: string) => ['ai', 'quiz', 'student', sessionId] as const,
  aiQuizResult: (quizId: string) => ['ai', 'quiz', 'result', quizId] as const,
  messageThreads: ['messages', 'threads'] as const,
  messageUnreadTotal: ['messages', 'unread-total'] as const,
  messageThreadMessages: (threadId: string) => ['messages', 'thread', threadId] as const,
  mentorAvailability: ['mentor', 'availability'] as const,
  mentorCalendar: (start: string, end: string) => ['mentor', 'calendar', start, end] as const,
  educationUniversities: (q: string) => ['education', 'universities', q] as const,
  educationSubjects: (grade: number) => ['education', 'subjects', grade] as const,
  educationExamSubjects: (track: string) => ['education', 'exam-subjects', track] as const,
  mentorSearch: (filters: Record<string, unknown>) => ['search', 'mentors', filters] as const,
  mentorPublicProfile: (mentorId: string) => ['search', 'mentor', mentorId] as const,
  publicListing: (listingId: string) => ['search', 'listing', listingId] as const,
  listingSlots: (listingId: string, start: string, end: string) =>
    ['search', 'slots', listingId, start, end] as const,
  mentorListings: ['mentor', 'listings'] as const,
  mentorListing: (listingId: string) => ['mentor', 'listing', listingId] as const,
  mentorWalletMe: ['mentor-wallet', 'me'] as const,
  mentorWalletTransactions: (filters: Record<string, unknown>) =>
    ['mentor-wallet', 'transactions', filters] as const,
  mentorWalletPayoutRequests: (filters: Record<string, unknown>) =>
    ['mentor-wallet', 'payout-requests', filters] as const,
  mentorWalletPayoutMethods: ['mentor-wallet', 'payout-methods'] as const,
  favouriteMentors: ['favourites', 'mentors'] as const,
  favouriteListings: ['favourites', 'listings'] as const,
  studentFavouriteMentors: (studentId: string) => ['favourites', 'student', studentId] as const,
  mentorMaterials: (tab: string) => ['materials', 'mentor', tab] as const,
  mentorMaterial: (materialId: string) => ['materials', 'mentor', 'detail', materialId] as const,
  studentMaterials: (tab: string) => ['materials', 'student', tab] as const,
  studentMaterial: (materialId: string) => ['materials', 'student', 'detail', materialId] as const,
  parentMaterials: (studentId: string, tab: string) => ['materials', 'parent', studentId, tab] as const,
  parentMaterial: (studentId: string, materialId: string) =>
    ['materials', 'parent', 'detail', studentId, materialId] as const,
  adminDashboard: ['admin', 'dashboard'] as const,
  adminMentorVerifications: ['admin', 'mentor-verifications'] as const,
  adminMentorVerification: (mentorId: string) => ['admin', 'mentor-verification', mentorId] as const,
  adminMentorProfiles: (filters: Record<string, unknown>) => ['admin', 'mentor-profiles', filters] as const,
  adminMentorProfile: (mentorId: string) => ['admin', 'mentor-profile', mentorId] as const,
  adminListings: (filters: Record<string, unknown>) => ['admin', 'listings', filters] as const,
  adminListing: (listingId: string) => ['admin', 'listing', listingId] as const,
  adminUsers: (filters: Record<string, unknown>) => ['admin', 'users', filters] as const,
  adminUser: (userId: string) => ['admin', 'user', userId] as const,
  discoveryFeed: (filters: Record<string, unknown>) => ['discovery', 'feed', filters] as const,
  discoverySaved: (filters: Record<string, unknown>) => ['discovery', 'saved', filters] as const,
  discoveryProfile: (mentorId: string) => ['discovery', 'profile', mentorId] as const,
  myContactRequests: (filters: Record<string, unknown>) => ['contact-requests', 'mine', filters] as const,
  mentorContactRequests: (filters: Record<string, unknown>) =>
    ['contact-requests', 'mentor', filters] as const,
  adminContactRequests: (filters: Record<string, unknown>) =>
    ['admin', 'contact-requests', filters] as const,
  adminReports: (filters: Record<string, unknown>) => ['admin', 'reports', filters] as const,
  adminMarketingCampaigns: (filters: Record<string, unknown>) =>
    ['admin', 'marketing', 'campaigns', filters] as const,
  adminMarketingCampaign: (id: string) => ['admin', 'marketing', 'campaign', id] as const,
  adminMarketingCampaignMetrics: (id: string, filters: Record<string, unknown>) =>
    ['admin', 'marketing', 'campaign-metrics', id, filters] as const,
  sponsoredCard: (query: Record<string, unknown>) => ['marketing', 'sponsored-card', query] as const,
};
